// Klartext-Check Pricing Configuration
// Maps Stripe products/prices to app plans

export interface KlartextPlanConfig {
  id: string;
  name: string;
  priceId: string;
  productId: string;
  priceMonthly: number; // in cents
  features: string[];
  highlight?: boolean;
  badge?: string;
}

export const KLARTEXT_PLANS: Record<string, KlartextPlanConfig> = {
  free: {
    id: 'free',
    name: 'Kostenlos',
    priceId: '',
    productId: '',
    priceMonthly: 0,
    features: [
      '3 Checks einmalig kostenlos',
      'Text & Bild-Analyse',
      'Sofortige Ergebnisse',
    ],
  },
  familie: {
    id: 'familie',
    name: 'Familie',
    priceId: 'price_1SoQmLKzOguV1kWje0b1fCOZ',
    productId: 'prod_TlyjFm37EwvVbQ',
    priceMonthly: 500,
    features: [
      'Unbegrenzte Checks',
      '2 Familien-Accounts',
      'Check-Historie speichern',
      'E-Mail-Support',
    ],
    badge: 'Beliebt',
    highlight: true,
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    priceId: 'price_1SoQmAKzOguV1kWjF29piYAG',
    productId: 'prod_TlyjS1fszXSdVz',
    priceMonthly: 900,
    features: [
      'Unbegrenzte Checks',
      'Check-Historie speichern',
      'Detaillierte Analysen',
      'Prioritäts-Support',
    ],
  },
  firma: {
    id: 'firma',
    name: 'Firma',
    priceId: 'price_1SoQmdKzOguV1kWjqxOxUdNn',
    productId: 'prod_TlykBdTR6G1VYV',
    priceMonthly: 2900,
    features: [
      'Unbegrenzte Checks',
      'Bis zu 10 Mitarbeiter',
      'Check-Historie speichern',
      'Priority-Support',
      'Monatlicher Sicherheitsreport',
    ],
  },
};

export const PLAN_ORDER = ['free', 'familie', 'pro', 'firma'] as const;

export function getPlanByProductId(productId: string): KlartextPlanConfig | null {
  return Object.values(KLARTEXT_PLANS).find(p => p.productId === productId) || null;
}

export function formatPrice(cents: number): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(cents / 100);
}
